import { FC, useState, useRef } from "react";
import {
  usePairSelect,
  useOutsideClick,
  usePairKeyboard,
  Tabs,
  SearchInput,
  PairList,
} from "features/select-pair";
import { TradingAssets } from "shared/model";
import { ChevronIcon } from "shared/ui";
import styles from "./PairSelect.module.css";

const tabs = [
  { label: "Currencies", value: TradingAssets.FOREX },
  { label: "Cryptocurrencies", value: TradingAssets.CRYPTO },
  { label: "Commodities", value: TradingAssets.COMMODITIES },
  { label: "Stocks", value: TradingAssets.STOCKS },
];

type Props = {
  disabled?: boolean;
};

export const PairSelect: FC<Props> = ({ disabled }) => {
  const {
    selectedPair,
    filteredPairs,
    activeTab,
    setActiveTab,
    handleSelect,
    search,
    setSearch,
  } = usePairSelect();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number>(-1);

  useOutsideClick(wrapperRef, () => setOpen(false));

  usePairKeyboard({
    open,
    filteredPairs,
    activeIndex,
    setActiveIndex,
    onSelect: (symbol) => {
      handleSelect(symbol);
      setOpen(false);
    },
    onClose: () => setOpen(false),
  });

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <button
        className={`${styles.trigger} button`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        disabled={disabled}
      >
        <span>{selectedPair}</span>
        <ChevronIcon
          fill="white"
          direction={open ? "up" : "down"}
          className={styles.chevron}
        />
      </button>
      {open && (
        <div className={styles.dropdown}>
          <Tabs tabs={tabs} activeTab={activeTab} onSelect={setActiveTab} />

          <div className={styles.listWrapper}>
            <SearchInput
              value={search}
              onChange={setSearch}
              onClear={() => setSearch("")}
            />

            <PairList
              pairs={filteredPairs}
              activeIndex={activeIndex}
              onSelect={(symbol) => {
                handleSelect(symbol);
                setOpen(false);
              }}
              onHover={setActiveIndex}
              itemRefs={itemRefs}
            />
          </div>
        </div>
      )}
    </div>
  );
};
